import { Box} from "@enaep-ng/benchmark";
import { ActionButtonRow, Title, ActionComponent, SplitLayout } from "@npd-ng/adp-component-library";
import {ModeSelectionProps } from "../typings/ViewTypes";
import { IADPState } from "shared/typings";
import { useSelector } from "react-redux";
import * as img from "shared/assets";
export const ModeSelectionView = (props: {actions: ActionComponent["action"][] }) => {
  
  const state = useSelector((state:{rootState:IADPState})=>state.rootState)
  const modeSelectionsProps: ModeSelectionProps = {
    title: state.currentLanguageContent?.modeSelectionView.title || "",
    
    actions: [
      {
        label:
          state.currentLanguageContent?.modeSelectionView
            .preAssessmentCheck.label || "",
        content:
          state.currentLanguageContent?.modeSelectionView
            .preAssessmentCheck.content || "",
        actionDescription:
          state.currentLanguageContent?.modeSelectionView
            .preAssessmentCheck.actionDescription || "",
        iconSrc: img.normal16,
        alt:state.currentLanguageContent?.imageAltText.verificationActionIcon as string,
        action: () => {props.actions[0]()}
      },
      {
        label:
          state.currentLanguageContent?.modeSelectionView.assessmentDay
            .label || "",
        content:
          state.currentLanguageContent?.modeSelectionView.assessmentDay
            .content || "",
        actionDescription:
          state.currentLanguageContent?.modeSelectionView.assessmentDay
            .actionDescription || "",
        iconSrc: img.star,
        alt:state.currentLanguageContent?.imageAltText.assessmentDayActionIcon as string,
        action: () => {props.actions[1]()}
      },
    ],
  };
  const { title, actions } = modeSelectionsProps;
  return (
    <SplitLayout logoAlt={state.currentLanguageContent?.imageAltText.naepLogo as string}>
      <Box>
        <Box
          sx={{
            '& [data-component="Heading"]': {
              color: "p.800",
              paddingBottom: "space-64",
            },
          }}
        >
          <Title content={title} style={{ fontWeight: "600" }} />
        </Box>
        <Box
          sx={{
            display: "flex",
          }}
        >
          <ActionButtonRow actionContainerStyle={{ marginLeft: "calc(8px * var(--zoom))" }} actions={actions} />
        </Box>
      </Box>
    </SplitLayout>
  );
};

